<!-- 我的论文 -->
<template>
    <div class="el-UserPaper">
        <el-row class="page_content">
            <h1 class="head_title">我的论文</h1>
            <el-row>
                <el-empty v-if="emptyShow" description="暂无论文信息"></el-empty>
                <template v-else>
                    <el-form ref="form" :model="form" label-width="120px">
                      <el-form-item label="论文名称 :">
                        {{dataInfo.dissertationTitle}}
                      </el-form-item>
                      <el-form-item label="指导老师 :">
                        {{dataInfo.teacherName}}
                      </el-form-item>
                      <el-form-item label="我的论文 :">
                        <el-row style="min-width: 500px;width: 50%;">
                            <el-upload
                              class="upload-demo"
                              :action="uploadUrl"
                              :before-upload="beforeUpload"
                              :on-preview="handlePreview"
                              :on-remove="handleRemove"
                              :on-success="handleSuccess"
                              :before-remove="beforeRemove"
                              :headers="headers"
                              :on-exceed="handleExceed"
                              :file-list="fileList || []">
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </el-row>
                      </el-form-item>
                      <el-form-item label="" v-if="fileList.length > 0">
                          <el-button size="small" type="primary" @click="onSubmit">确定上传</el-button>
                           <el-button size="small" type="success" @click="onPreview">预览</el-button>
                      </el-form-item>
                      <el-form-item label="留言 :">
                        <el-row v-html="dataInfo.teacherMessage"></el-row>
                      </el-form-item>
                    </el-form>
                </template>
            </el-row>
        </el-row>

        <el-dialog
          title=""
          :visible.sync="dialogVisible"
          top="20px"
          width="1200px">
          <iframe :src="previewUrl" width="100%" height="500px"></iframe>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import {getCookieForRoleTag} from "../../common/ulit";
export default {
  name: "UserPaper",
  data() {
    return {
        uploadUrl: this.$baseUrl + "/api/file/update.do", //请求接口
        headers: {token:getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null}, //请求头
        fileList:[],
        dataInfo: {},
        accept:"",
        emptyShow:true,
        dialogVisible:false,
        previewUrl:"",
        form:{}
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
     // 上传之前，可以做一些校验
     beforeUpload(file) {
       if(!this.$isEmpty(this.accept)){
         const fileName = file.name;
         const fileType = fileName.substring(fileName.lastIndexOf('.'));
         // jpeg,.png,.jpg,.bmp,.gif
         if (this.accept.toUpperCase().indexOf(fileType.toUpperCase()) < 0) {
           this.$message.warning("文件类型错误，请重新上传！")
           return false;
         }
       }
       console.log('beforeUpload')
       const isLt5M = file.size / 1024 / 1024 < 500
       if (!isLt5M) {
         this.$message.error('上传文件大小不能超过 500MB!')
       }
       return isLt5M
     },
     handleRemove(file, fileList) {
       this.fileList = fileList;
       this.$emit('onSuccess', this.fileList);
     },
     handlePreview(file) {
       console.log(file);
       //this.$downLoadFile(file.url,file.name);
     },
     handleExceed(files, fileList) {
       this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
     },
     beforeRemove(file, fileList) {
       //return this.$confirm(`确定移除 ${ file.name }？`);
     },
     // 上传成功后的回调
     handleSuccess(res, file) {
       if(res.code == 0){
           this.fileList = [];
         this.fileList.push({
           name:res.data.nameFormat,
           url:res.data.url
         });
       }else{
         this.$message.error(res.msg);
       }
     },
    getInfo(){
        const loading = this.$loading({
          lock: true,
          text: '加载信息中......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$store.dispatch("user/getDissertation").then((ret) => {
          loading.close();
          if (ret.code === 0 || ret.code === '0') {
            if(!this.$isEmpty(ret.data)){
                this.emptyShow = false;
                this.dataInfo = ret.data;
                if(!this.$isEmpty(ret.data.dissertationUrl)){
                    this.fileList = [];
                    this.fileList.push({
                        name:"我的论文",
                        url:ret.data.dissertationUrl
                    })
                }
            }
          } else {
            this.$message({
               message: ret.msg,
               type: 'warning',
               onClose:()=>{
               　//this.$closeWin();
               }
            });
          }
        }).catch(() => {
          loading.close();
        });
    },
    onSubmit(){ //提交上传文档
        if(this.fileList.length <= 0){
            this.$message.warning("请上传论文！")
            return;
        }
        const loading = this.$loading({
          lock: true,
          text: '提交中......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let param = {
            dissertationUrl:this.fileList[0].url,
            dissertationId:this.dataInfo.dissertationId
        }
        this.$store.dispatch("user/updateDissertationUrl",param).then((ret) => {
          loading.close();
          if (ret.code === 0 || ret.code === '0') {
            this.$message.success("保存成功！");
            this.getInfo();
          } else {
            this.$message({
               message: ret.msg,
               type: 'warning',
               onClose:()=>{
               　//this.$closeWin();
               }
            });
          }
        }).catch(() => {
          loading.close();
        });
    },
    onPreview(){ //预览
        this.dialogVisible = true;
        this.previewUrl = "http://39.108.104.1/op/view.aspx?src=" + this.$baseUrl+this.dataInfo.dissertationUrl;
        // this.previewUrl = "http://39.108.104.1/op/view.aspx?src=http://www.905.cn/server/filesystem/temp/金融工程/ppt/金融工程-P1-现金流的时间价值.pptx";
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-UserPaper{
    .wd{
        color: @red;
    }
    .el-form-item__label{
        font-size: 16px;
    }
    img{
        max-width: 100%;
        height: auto;
    }
    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
  }
</style>



// WEBPACK FOOTER //
// src/pages/dissertation/UserPaper.vue